<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  export let emoji: { path: string };
  export let name: string;
  export let unselected = false;
  export let selected = false;

  let dispatch = createEventDispatcher();
</script>

<div>
  <button
    on:click={event => dispatch('click', event)}
    style={unselected
      ? 'filter: grayscale(100%); opacity: 0.8; transform: scale(1)!important;'
      : selected
      ? 'transform: scale(1.2)!important;'
      : ''}
  >
    <img alt="Select {name}" src={'https://emoji.onhighloop.com/' + emoji.path} />
    <!-- Emoji provided by Twemoji (https://github.com/twitter/twemoji) -->

    <p style={selected ? 'color: var(--loop-foreground);' : undefined}>
      {name}
    </p>
  </button>
</div>

<style>
  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* height: 100%; */
  }

  img {
    height: 30px;
    pointer-events: none;
    user-select: none;
  }

  p {
    font-size: 12px;
    margin: 4px 0px 0px 0px;
    color: var(--loop-accent2);
  }

  button {
    border: none;
    background: none;
    transition: all 0.2s;
  }

  button:hover,
  button:focus {
    transform: scale(1.2);
  }
</style>
